<template>
  <div class="terminate-button">
    <b-modal :active.sync="confirmModal" has-modal-card style="width: auto;">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Terminate Account</p>
          <button type="button" class="delete" @click="() => confirmModal = false" />
        </header>
        <div class="modal-card-body">
          <div style="line-height: 2rem; margin-bottom: 20px;">
            <p>This action cannot be undone. This will permanently delete <b>{{ firm.name }}</b>.</p>
            <p>Please type in the name of the firm to confirm.</p>
          </div>
          <b-field label="Name*">
            <b-input v-model="confirmText"></b-input>
          </b-field>
        </div>
        <footer class="modal-card-foot">
          <b-button label="CANCEL" @click="() => confirmModal = false" />
          <b-button label="TERMINATE" type="is-danger" :loading="loading" :disabled="!confirmedText" @click="terminate" />
        </footer>
      </div>
    </b-modal>

    <b-button type="is-danger" @click="() => confirmModal = true" v-if="canBeTerminated">
      TERMINATE ACCOUNT
    </b-button>
  </div>
</template>

<script>
import { FirmService } from "@/services/firm.service";

export default {
  props: {
    firm: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    canBeTerminated: false,
    confirmModal: false,
    confirmText: "",
    loading: false
  }),
  computed: {
    confirmedText() {
      return this.firm.name == this.confirmText;
    }
  },
  mounted() {
    this.checkCanBeTerminated();
  },
  methods: {
    async checkCanBeTerminated() {
      try {
        this.canBeTerminated = await FirmService.canBeTerminated(
          this.firm.id
        ).then(response => response.data);
      } catch (err) { }
    },
    async terminate() {
      if (!this.confirmedText) return;
      try {
        this.loading = true;
        await FirmService.terminate(this.firm.id);
        // Logout user
        localStorage.clear();
        this.$store.dispatch('Auth/clearToken');
      } catch (err) {
        this.loading = false;
        throw err;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/partials/TerminateButton.vue